import { create } from 'zustand';

export interface MarketInfo {
  market_id: string;
  display_name: string;
  state: string;
  state_full: string;
  center_lat: number;
  center_lng: number;
  zip_prefix: string;
  submarket_count: number;
  assessor_name: string;
  permit_source_name: string;
}

/** Static market definitions — matches backend config_markets registry */
export const MARKETS: MarketInfo[] = [
  {
    market_id: 'philadelphia',
    display_name: 'Philadelphia',
    state: 'PA',
    state_full: 'Pennsylvania',
    center_lat: 39.9526,
    center_lng: -75.1652,
    zip_prefix: '191',
    submarket_count: 29,
    assessor_name: 'Philadelphia OPA',
    permit_source_name: 'Philadelphia L&I',
  },
  {
    market_id: 'norfolk',
    display_name: 'Norfolk',
    state: 'VA',
    state_full: 'Virginia',
    center_lat: 36.8508,
    center_lng: -76.2859,
    zip_prefix: '235',
    submarket_count: 0,
    assessor_name: 'Norfolk REVA',
    permit_source_name: 'Norfolk DPB',
  },
  {
    market_id: 'winston_salem',
    display_name: 'Winston-Salem',
    state: 'NC',
    state_full: 'North Carolina',
    center_lat: 36.0999,
    center_lng: -80.2442,
    zip_prefix: '271',
    submarket_count: 0,
    assessor_name: 'Forsyth County GIS',
    permit_source_name: 'Winston-Salem Inspections',
  },
];

interface MarketState {
  activeMarket: MarketInfo;
  setActiveMarket: (marketId: string) => void;
}

export const useMarketStore = create<MarketState>((set) => ({
  activeMarket: MARKETS[0], // Philadelphia default
  setActiveMarket: (marketId: string) => {
    const market = MARKETS.find((m) => m.market_id === marketId);
    if (market) {
      set({ activeMarket: market });
    }
  },
}));

/** Convenience hook: returns just the active market info */
export const useActiveMarket = () => useMarketStore((s) => s.activeMarket);
